import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { contactColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';

import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { ContactsRepository } from '@Repositories/Stammdaten';

export function FrameListContact() {
    const hasPermission = useHasPermission();
    const module = useListApi(ContactsRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings
            layoutSettingsContext={EnumFrontendLayoutSetting.ContactsTableLayout}
            name={'ContactList'}
            columns={contactColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenContactCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
